<template>
  <div class="wrapper">
    <div class="echarts" id="chartMap" ref="chartMap"></div>
  </div>
</template>

<script>
import {getUserInfo} from "@/util/index";
import {mapState} from 'vuex'
import greenCircle from '@/asset/img/MapIcon/SmallGreen.png'
import redCircle from '@/asset/img/MapIcon/SmallRed.png'
import orangeCircle from '@/asset/img/MapIcon/ExceedOrange.png'
import blackCircle from '@/asset/img/MapIcon/SmallBlack.png'
import greyCircle from '@/asset/img/MapIcon/SmallGrey.png'
import redFiveStar from '@/asset/img/MapIcon/BigRed.png'
import {gxxq, gxnq, gxdq,tfxq,gxq} from '../../assets/gaoxinqu.js'

import decBlockTitle from '../decorations/blockTitle2'
import {defineLocale} from 'moment'
import axios from "axios";
import { gxdq1, gxxq1, gxnq1, jys, tfxq1, slq, whq, pdq, jjq, qyq, jnq, chq, lqyq, qbjq, xdq, wjq, jtx, dyx, xjx, djys, pzs, czs, zls, pjx} from '../../assets/chengdushi.js'
import { sanwayao1Km, sanwayao3Km,shahepu1Km,shahepu3Km,dashi1Km,dashi3Km,shili1Km,shili3Km,jinbo1Km,jinbo3Km,jinquanlianghe1Km,jinquanlianghe3Km,longquan1Km,longquan5Km,kexuecheng1Km,kexuecheng3Km,huayang1Km,huayang3Km,qingbaijiang1Km,qingbaijiang3Km,guanghua1Km,guanghua3Km} from "@/view/bigscreen/assets/CDGuoKongDian";


const iconSize = new AMap.Size(12, 12)
const largeIconSize = new AMap.Size(14, 14)
const greenCircleIcon = new AMap.Icon({
  size: iconSize,
  image: greenCircle,
  imageSize: iconSize
})

const redCircleIcon = new AMap.Icon({
  size: iconSize,
  image: redCircle,
  imageSize: iconSize
})

const orangeCircleIcon = new AMap.Icon({
  size: largeIconSize,
  image: orangeCircle,
  imageSize: largeIconSize
})

const greyCircleIcon = new AMap.Icon({
  size: largeIconSize,
  image: greyCircle,
  imageSize: largeIconSize
})

const blackCircleIcon = new AMap.Icon({
  size: largeIconSize,
  image: blackCircle,
  imageSize: largeIconSize
})

const redFiveStar1 = new AMap.Icon({
  size: new AMap.Size(20, 20),
  image: redFiveStar,
  imageSize: new AMap.Size(20, 20)
})

const infoWindow = new AMap.InfoWindow({
  isCustom: true,
  content: null,
  anchor: 'top-left',
  offset: new AMap.Pixel(16, -45),
  closeWhenClickMap: true
})

export default {
  name: 'dotMapDistrict',
  components: {
    decBlockTitle
  },
  props: {
    contentData: {
      type: Object,
      default: () => {
        return {
          areaId: null,
          code: ''
        }
      }
    },
    isShowExceed: {
      type: Boolean
    },
    isShowEmphasisDot: {
      type: Object
    },
    onlineDevice: {
      type: Object,
      default: () => {
        return {}
      }
    },
    countyLevelData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pointWorkType: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      filterAnjiGKDPointData: [],
      AnjiGuoKongDian: [//安吉现在的国控点经纬度
        { id: 'point1', lat: 30.595802, lng: 119.701200 },//凤凰山水库大坝
        { id: 'point2', lat: 30.636576, lng: 119.690545 },//安吉县实验小学（玉华校区）
      ],
      currentCircle: [], // 用于保存安吉地图上的国控点圆形实例
      AnjiKMValue:1000,//存储的topHeader选择的安吉国控点的值,默认统计1公里的
      GKDData:{},//存储的国控点的数据
      isMapInit:false,//一开始默认地图的初始化不执行，使用Boolean值确保初始化一次
      showOneKM:{},//存储附近一公里的数据

      myCharts: null,
      aliMap: null,
      map: {},
      parentJson: [],
      areaPath: [],
      geoJsonData: {},
      mapData: [],
      parentCode: ['100000'],
      dotColor: ['#FF001A', '#78ff79', '#FEFF65', '#AEAEAE', '#000000'], //红 绿色 黄色 灰色 黑色
      config: {
        data: [],
        showValue: true,
        colors: ['#37a2da']
      },
      dotsCollection: [],
      key: 1,
      showMore: false,
      tableKey: 1,
      lat: '',
      lng: '',
    }
  },
  async mounted() {
    // await this.initData()
  },
  computed: {
    ...mapState(['topBoardData'])
  },
  methods: {
    //该方法让index页面调用，直接绕过center页面调用该方法
    changeAnjiKMMap(AnjiKMValue){
      if(AnjiKMValue !== ''){
        this.AnjiKMValue = AnjiKMValue
        //拿到国控点过滤的数据
        this.filterAnjiGKDPointData = this.filterAnjiPointData(this.onlineDevice.listDevice)
      }
      // 清除安吉地图上有上一次国控点圆形的实例
      if (this.currentCircle.length > 0) {
        this.currentCircle.forEach(circle => circle.setMap(null));
        this.currentCircle = []; // 清空数组以便重新填充
      }
      // 清空之前的点位标记
      if (this.dotsCollection && this.dotsCollection.length > 0) {
        this.dotsCollection.forEach(marker => {
          marker.setMap(null);
        });
        this.dotsCollection = [];
      }
      this.drawAliMap(AnjiKMValue === ''? false:true)
    },
    //获取到成都市的点位区域数据
    async getChengDuPoint(){
      const areaCode = {
        AreaCode: '510100'
      }
      await this.$post("admin/listLocalePosition", areaCode).then(res => {
        const counters = {};
        const data = res.list;

        for (const key in data) {
          const item = data[key];
          // 获取区域名称和简写
          const areaName = item.area;
          const areaAbbreviation = getAreaAbbreviation(areaName);
          // 初始化 counters 对象中的项
          if (!counters[item.name[0]]) {
            counters[item.name[0]] = {hexinNum: 0, zhongdianNum: 0};
          }
          // 检查是否包含“核心区域”或“重点区域”
          if (item.name[0].includes('核心区域')) {
            counters[item.name[0]].hexinNum++;
            // 更新区域数量
            if (!counters[item.name[0]][areaAbbreviation]) {
              counters[item.name[0]][areaAbbreviation] = {green: 0, red: 0,grey: 0, black: 0};
            }
            // 根据 status 更新计数
            switch (item.status) {
              case 'NORMAL':
              case 'ALARM':
                counters[item.name[0]][areaAbbreviation].green++;
                break;
              case 'EXCESS':
                counters[item.name[0]][areaAbbreviation].red++;
                break;
              case 'DOWN':
                counters[item.name[0]][areaAbbreviation].grey++;
                break;
              case 'OFF':
                counters[item.name[0]][areaAbbreviation].black++;
                break;
              default:
                break;
            }
          } else if (item.name[0].includes('重点区域')) {
            counters[item.name[0]].zhongdianNum++;
            // 更新区域数量
            if (!counters[item.name[0]][areaAbbreviation]) {
              counters[item.name[0]][areaAbbreviation] = {green: 0, red: 0,grey: 0, black: 0};
            }
            // 根据 status 更新计数
            switch (item.status) {
              case 'NORMAL':
              case 'ALARM':
                counters[item.name[0]][areaAbbreviation].green++;
                break;
              case 'EXCESS':
                counters[item.name[0]][areaAbbreviation].red++;
                break;
              case 'DOWN':
                counters[item.name[0]][areaAbbreviation].grey++;
                break;
              case 'OFF':
                counters[item.name[0]][areaAbbreviation].black++;
                break;
              default:
                break;
            }
          }
        }
        // console.log('counters', counters);
        this.GKDData = counters;
      })
      // 区域名称到简写的映射函数
      function getAreaAbbreviation(areaName) {
          switch (areaName) {
            case '高新东区':
              return 'GXDQ';
            case '高新西区':
              return 'GXXQ';
            case '高新南区':
              return 'GXNQ';
            case '简阳市':
              return 'JYS';
            case '天府新区':
              return 'TFXQ';
            case '双流区':
              return 'SLQ';
            case '武侯区':
              return 'WHQ';
            case '郫都区':
              return 'PDQ';
            case '锦江区':
              return 'JJQ';
            case '青羊区':
              return 'QYQ';
            case '金牛区':
              return 'JNQ';
            case '成华区':
              return 'CHQ';
            case '龙泉驿区':
              return 'LQYQ';
            case '青白江区':
              return 'QBJQ';
            case '新都区':
              return 'XDQ';
            case '温江区':
              return 'WJQ';
            case '金堂县':
              return 'JTX';
            case '大邑县':
              return 'DYX';
            case '新津县':
              return 'XJX';
            case '都江堰市':
              return 'DJYS';
            case '彭州市':
              return 'PZS';
            case '崇州市':
              return 'CZS';
            case '邛崃市':
              return 'ZLS';
            case '蒲江县':
              return 'PJX';
            default:
              return '';
          }
        }


    },
    addPolygon(data, name) {
       // console.log('要绘画的线条',data)
      //确保地图只初始化一次
      if (!this.isMapInit) {
        this.aliMap = new AMap.Map('chartMap', {
          resizeEnable: true,
          center: [104.18554097414017, 30.32420946420142],
          mapStyle: 'amap://styles/181dc194075339e4e2ca424d04024247'
        });
        this.isMapInit = true;
        // this.drawAliMap();
      }

      let polygon = new AMap.Polygon({
        path: data,
        strokeColor: '#020202',
        fillOpacity: 0.2,
        fillColor: '#CCF3FF',
        strokeOpacity: 1,
        strokeWeight: 1,
        extData: { name }  // 添加区的名称
      });

      //当如果是成都的时候鼠标悬停展示悬停在哪个区
      if((this.contentData.code == "510100")){
        // 添加鼠标悬停事件
        polygon.on('mouseover', (e) => {
          const name = e.target.getExtData().name;
          this.showTooltip(name, e.lnglat);
        });

        polygon.on('mouseout', () => {
          this.hideTooltip();
        });
      }

      this.aliMap.add(polygon);
      this.aliMap.setFitView();
    },
    //当时成都的时候鼠标移入展示出在哪个区
    showTooltip(name, lnglat) {
      this.tooltip = new AMap.Marker({
        position: lnglat,
        offset: new AMap.Pixel(-50, -20),
        content: `<div style="background-color: white; border: 1px solid black; padding: 5px;color: #006FF1">${name}</div>`
      });
      this.aliMap.add(this.tooltip);
    },
    //鼠标移出不展示
    hideTooltip() {
      if (this.tooltip) {
        this.aliMap.remove(this.tooltip);
        this.tooltip = null;
      }
    },
    initData() {
      this.getData()
      var user = getUserInfo().Info
      if (user && user.name && user.name == "成都高新区在线油烟监管") {
        this.addPolygon(gxq);
        this.drawAliMap();
      } else {
        if (this.contentData.code == "gxnq") {
          this.addPolygon(gxnq);
          this.drawAliMap();
        } else if (this.contentData.code == "gxxq") {
          this.addPolygon(gxxq);
          this.drawAliMap();
        } else if (this.contentData.code == "gxdq") {
          this.addPolygon(gxdq);
          this.drawAliMap();
        } else if ((this.contentData.code == "tfxq")) {
          this.addPolygon(tfxq);
          this.drawAliMap();
        } else if ((this.contentData.code == "510100")) {//当前是成都市的，展示出成都市的各个区分界线
          console.log('此时是成都市在线油烟监管')
          this.addPolygon(gxdq1, '高新东区');
          this.addPolygon(gxxq1, '高新西区');
          this.addPolygon(gxnq1, '高新南区');
          this.addPolygon(jys, '简阳市');
          this.addPolygon(tfxq1, '天府新区');
          this.addPolygon(slq, '双流区');
          this.addPolygon(whq, '武侯区');
          this.addPolygon(pdq, '郫都区');
          this.addPolygon(jjq, '锦江区');
          this.addPolygon(qyq, '青羊区');
          this.addPolygon(jnq, '金牛区');
          this.addPolygon(chq, '成华区');
          this.addPolygon(lqyq, '龙泉驿区');
          this.addPolygon(qbjq, '青白江区');
          this.addPolygon(xdq, '新都区');
          this.addPolygon(wjq, '温江区');
          this.addPolygon(jtx, '金堂县');
          this.addPolygon(dyx, '大邑县');
          this.addPolygon(xjx, '新津县');
          this.addPolygon(djys, '都江堰市');
          this.addPolygon(pzs, '彭州市');
          this.addPolygon(czs, '崇州市');
          this.addPolygon(zls, '邛崃市');
          this.addPolygon(pjx, '蒲江县');
          this.drawAliMap();
        } else {
          console.log("未匹配到区域")
          this.initAliMap(this.contentData.code)
        }
      }

    },
    calcTableHeight() {
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.tableHeight = this.$refs.table.$el.parentElement.offsetHeight;
        }
      })
    },
    showDot(type) {
      this.dotsCollection.forEach(marker => {
        if (type == '0') { //全部显示
          marker.show()
        } else if (type == '1') { //显示红码
          if (marker.getExtData().HealthCodeColor == "Red") {
            marker.show()
          } else {
            marker.hide()
          }
        } else if (type == '2') { //显示绿码
          if (marker.getExtData().HealthCodeColor == "Green") {
            marker.show()
          } else {
            marker.hide()
          }
        } else if (type == '8') { //显示绿码
          if (marker.getExtData().HealthCodeColor == "Yellow") {
            marker.show()
          } else {
            marker.hide()
          }
        } else if (type == '3') { //显示在线
          if (marker.getExtData().Status != "OFF" && marker.getExtData().Status != "DOWN") {
            marker.show()
          } else {
            marker.hide()
          }
        } else if (type == '4') { //显示达标
          if (marker.getExtData().Status == "NORMAL") {
            marker.show()
          } else {
            marker.hide()
          }
        }  else {  //显示超标
          if (marker.getExtData().Status == "EXCESS") {
            marker.show()
          } else {
            marker.hide()
          }
        }
      })
    },
    eventLocaleShow(mn){
      var exist = false
      this.dotsCollection.forEach(marker => {
        const targetMn = marker.getExtData().Mn
        if (targetMn === mn) {
          exist = true
          infoWindow.setContent(marker.getExtData().Content)
          marker.show()
          infoWindow.open(this.aliMap, marker.getPosition())
        } else {
          marker.hide()
        }
      })
      if (!exist) {
        infoWindow.setContent()
      }
    },

    getDistance(lat1, lng1, lat2, lng2) {
      let EARTH_RADIUS = 6378.137;
      let radLat1 = lat1 * Math.PI / 180.0;
      let radLat2 = lat2 * Math.PI / 180.0;
      let a = radLat1 - radLat2;
      let b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
      let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000;
      return s.toFixed(2)
    },

    initAliMap(areaCode) {
      // console.log('初始化地图')
      const that = this
      that.aliMap = new AMap.Map('chartMap', {
        resizeEnable: true,
        mapStyle: 'amap://styles/181dc194075339e4e2ca424d04024247'
      })
      const polygon = new AMap.Polygon({
        strokeWeight: 1,
        strokeColor: '#CC66CC',
        fillOpacity: 0.2,
        fillColor: '#CCF3FF',
        zIndex: 50,
      })
      // done用于district.search异步操作
      const done = function () {
        // 地图自适应
        that.aliMap.add(polygon)
        that.aliMap.setFitView()
        that.drawAliMap()
      }
      let district
      AMap.plugin('AMap.DistrictSearch', function () {
        // 创建行政区查询对象
        district = new AMap.DistrictSearch({
          // 返回行政区边界坐标等具体信息
          extensions: 'all',
          // 设置查询行政区级别为 区
          level: areaCode.length <= 6?'district':'biz_area',
        })
      })
      district.search(areaCode.substring(0, 6), function (status, result) {
        // 获取区的边界信息
        if(result.districtList) {
          that.lat = result.districtList[0].center["lat"]
          that.lng = result.districtList[0].center["lng"]
          polygon.setPath(result.districtList[0].boundaries)
        } else {
          that.lat = ""
          that.lng = ""
        }
        done()
      })
      console.log('aliMap done!')
    },
    stoveNumFormatter(StoveNum) {
      let r
      if (StoveNum > 6) {
        r = '大'
      } else if (StoveNum > 3) {
        r = '中'
      } else {
        r = '小'
      }
      return r
    },
    dotColorAndStatusFormatter(Status) {
      let r = []
      switch (Status) {
        case 'NORMAL':
          r = [1, '达标']
          break
        case 'EXCESS':
          r = [1, '超标']
          break
        case 'DOWN':
          r = [3, '离线']
          break
        case 'OFF':
          r = [4, '异常离线']
          break
        case 'ALARM':
          r = [1, '预警']
          break
        default:
          r = [4, '未知状态']
      }
      return r
    },
    dotColorStatusExeFormatter(Status) {
      var r = 3
      switch (Status) {
        case 'NORMAL':
          r = 1
          break
        case 'EXCESS':
          r = 0
          break
        case 'DOWN':
          r = 3
          break
        case 'OFF':
          r = 4
          break
        case 'ALARM':
          r = 2
          break
      }
      return r
    },
    dotColorFormatter(Status) {
      var r = blackCircleIcon
      switch (Status) {
        case 'NORMAL':
          r = greenCircleIcon
          break
        case 'EXCESS':
          r = redCircleIcon
          break
        case 'DOWN':
          r = greyCircleIcon
          break
        case 'OFF':
          r = blackCircleIcon
          break
        case 'redFiveStar':
          r = redFiveStar1
          break
        case 'ALARM':
          r = greenCircleIcon
          break
      }
      return r
    },
    //封装国控点的区域图线（核心区域和重点区域）
    fixedPolygon(areaLine) {
      new AMap.Polyline({
        path: areaLine,
        strokeColor: '#FF0000', // 红色线条
        strokeWeight: 2,         // 线条宽度
        strokeOpacity: 1,        // 线条透明度
        zIndex: 1,
        map: this.aliMap
      });
    },
    //封装固定在地图上文本标签
    fixedMarkerLable(name,position,offset){
      const [x, y] = offset;//解构位置偏移量
      new AMap.Text({
        text: name,
        position: position,
        offset: new AMap.Pixel(x, y), // 调整文本相对于标记的位置
        style: {
          color: '#006FF1',
          fontSize: '14px'
        },
        map: this.aliMap
      });
    },

    // 计算两点之间的距离（单位：米）
    calculateDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // 地球半径
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLon = (lon2 - lon1) * Math.PI / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c * 1000; // 距离单位：米
    },
    //传入总坐标点位，过滤符合的点位
    filterAnjiPointData(pointData){
      //安吉的地图根据选择的国控点范围渲染范围内的点位
      const filterAnjiData = []
      for (var i = 0; i < pointData.length; i++) {
        var item = pointData[i]
        const lat = parseFloat(item.Lat);
        const lng = parseFloat(item.Lng);

        this.AnjiGuoKongDian.forEach(point => {
          const distance = this.calculateDistance(lat, lng, point.lat, point.lng);
          if (distance <= this.AnjiKMValue) { // this.AnjiKMValue是topHeader选择的国控点范围
            filterAnjiData.push(item)
          }
        });
      }
      return filterAnjiData
    },
    //在地图上标注点位
    async drawAliMap(isfilterAnjiData) {
      const that = this;
      let deviceDetail = [];
      if (isfilterAnjiData) {
        // 使用安吉过滤后的数据
        deviceDetail = this.filterAnjiGKDPointData || [];
      } else {
        if (this.onlineDevice && this.onlineDevice.listDevice && this.onlineDevice.listDevice.length) {
          deviceDetail = await this.onlineDevice.listDevice;
        }
      }
      // if (this.onlineDevice.listDevice.length && this.onlineDevice.listDevice ) {
      //   deviceDetail = await this.onlineDevice.listDevice;
      // }
      // const that = this
      // const deviceDetail = await this.onlineDevice && this.onlineDevice.listDevice && this.onlineDevice.listDevice.length > 0 ? this.onlineDevice.listDevice : []

      //拿到当前的areaCode，判断是不是成都的
      const areaCode = sessionStorage.getItem('areaCode');
      //这样拿到的是string字符串
      const accountUserStr = sessionStorage.getItem('user');
      const accountUser = JSON.parse(accountUserStr)

      //成都市账号登录切换成重点区域地图进去的，手动清空点位信息
      if(this.contentData.code === "510100"){
        deviceDetail.length = 0;
      }
      // console.log('地图中的点位数据',deviceDetail)
      for (var i = 0; i < deviceDetail.length; i++) {
        // 剔除超范围的经纬度
        if (this.lat != "" && this.lng != "") {
          var dist = this.getDistance(this.lat, this.lng, deviceDetail[i].Lat, deviceDetail[i].Lng)
          if (dist > 50) {
            continue;
          }
        }
        var item = deviceDetail[i]
        var healthStatusColor = that.dotColor[this.dotColorStatusExeFormatter(item.Status)]
        var healthColor = item.HealthCodeColor === 'Green' ? '#78ff79' : (item.HealthCodeColor === 'Red' ? '#c70b0b' : '#FEFF65')
        var scale = that.stoveNumFormatter(item.StoveNum)
        var r = that.dotColorAndStatusFormatter(item.Status)
        var intimeColor = that.dotColor[r[0]]
        var content = `
      <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:300rem;">
        <p>
        <span style="color:#c7c7cc">店铺名称：</span>
        <span style="color:#c7c7cc">${item.CustomerName}</span>
        </p>
        <p>
          <div style="display:inline-block;color:#c7c7cc">实时状态：</div>
          <div style="width:10px;height:10px;background-color:${intimeColor};display:inline-block;border-radius:50%;margin-right:5px"></div>
          <span style="color:#c7c7cc">(${r[1]})</span>
          <div style="display:inline-block;color:#c7c7cc">排放状态码：</div>
          <div style="width:10px;height:10px;background-color:${healthStatusColor};display:inline-block;border-radius:50%;margin-right:5px"></div>
        </p>
        <p>
          <div style="display:inline-block;color:#c7c7cc">红绿码状态：</div>
          <div style="width:10px;height:10px;background-color:${healthColor};display:inline-block;border-radius:50%;margin-right:5px"></div>
        </p>
        <p>
          <span style="color:#c7c7cc">店铺规模：</span>
          <span style="color:#c7c7cc">${scale}</span>
          <span style="margin-left:4px;color:#c7c7cc">灶头数：</span>
          <span style="color:#c7c7cc">${item.StoveNum}</span>
        </p>
        <p>
          <span style="color:#c7c7cc;">联系人：</span>
          <span style="color:#c7c7cc;">${item.CustomerName}</span>
        </p>
        <p>
          <span style="margin-left:4px;color:#c7c7cc">联系电话：</span>
          <span style="color:#c7c7cc">${item.CustomerMobile}</span>
        </p>
        <h5 style="color:#c7c7cc;font-size:14px;margin:5px 0 0;">监测点信息</h5>
        <p>
          <span style="color:#c7c7cc">监测点名称：</span>
          <span style="color:#c7c7cc">${item.LocaleName}</span>
        </p>
        <p>
          <span style="color:#c7c7cc">所属单位：</span>
          <span style="color:#c7c7cc">${item.OwnerName}</span>
        </p>
        <p>
          <span style="color:#c7c7cc">菜系：</span>
          <span style="color:#c7c7cc">${item.CuisineName}</span>
        </p>
        <p>
          <span style="color:#c7c7cc">地址：</span>
          <span style="color:#c7c7cc">${item.Addr}</span>
        </p>
        <p>
          <span style="color:#c7c7cc">设备：</span>
          <span style="color:#c7c7cc">${item.MN}</span>
        </p>
      </div>
    `
        const marker = new AMap.Marker({
          position: [item.Lng, item.Lat],
          zIndex: 1,
          icon: this.dotColorFormatter(item.Status),
          extData: {
            Status: item.Status,
            HealthCodeColor: item.HealthCodeColor,
            Mn: item.MN,
            Content: content
          }
        })
        that.dotsCollection.push(marker)
        marker.on('mouseover', function (content) {
          return function () {
            infoWindow.setContent(content)
            infoWindow.open(that.aliMap, marker.getPosition())
          }
        }(content))

        marker.on('mouseout', function (content) {
          return function () {
            infoWindow.setContent("")
            infoWindow.open(that.aliMap, marker.getPosition())
          }
        }(content))
        marker.setMap(that.aliMap)
      }

      // const token = sessionStorage.getItem('token');
      //下面是安吉的
      if(areaCode == 330523){//当前是安吉的
        // this.$get("admin/listBasicDataOfLocale", ).then(res => {
          const data = deviceDetail
          const results = {
            point1: { onlineStatus: 0, Management: 0, notManagement: 0 },
            point2: { onlineStatus: 0, Management: 0, notManagement: 0 }
          };
          // 处理数据,统计国控点附近有多少经营和非经营的点位
          data.forEach(item => {
            const lat = parseFloat(item.Lat);
            const lng = parseFloat(item.Lng);
            this.AnjiGuoKongDian.forEach(point => {
              const distance = this.calculateDistance(lat, lng, point.lat, point.lng);
              if (distance <= this.AnjiKMValue) { // this.AnjiKMValue是topHeader选择的国控点范围
                results[point.id].onlineStatus += 1;
                const workType = this.pointWorkType.find(typeItem => typeItem.id === item.ManagementTypes);
                if (workType && workType.type === 1) {
                  results[point.id].Management += 1;
                } else {
                  results[point.id].notManagement += 1;
                }
              }
            });
          });
          // 打印结果
          this.showOneKM = results
          // 新增的固定点位
          const newMarker = new AMap.Marker({
            text:'凤凰山水库大坝',
            position: [119.701200,30.595802],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',//设置地图标记的锚点位置
            offset: new AMap.Pixel(0, 0),//设置图标的偏移量，加入上面这两个即可解决地图缩放标记点不在圆心的问题
            zIndex: 1
          })
          newMarker.setMap(that.aliMap)
          // 创建信息窗口
          const infoWindow1 = new AMap.InfoWindow({
            isCustom: true,// 禁用默认样式
            content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:300rem;">
                   <p>
                  <span style="color:#c7c7cc">凤凰山水库大坝${this.AnjiKMValue}米点位信息:</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">餐饮店：</span>
                  <span style="color:#c7c7cc">${this.showOneKM.point1.Management}家</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">机关食堂：</span>
                  <span style="color:#c7c7cc">${this.showOneKM.point1.notManagement}家</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">在线监测点：</span>
                  <span style="color:#c7c7cc">${this.showOneKM.point1.onlineStatus}家</span>
                  </p>
                </div>
              `, // 信息窗口的内容
            offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
          });
          // 绑定点击事件
          newMarker.on('mouseover', function() {
            infoWindow1.open(that.aliMap, newMarker.getPosition());
          });
          // 绑定鼠标移出事件，关闭信息窗口
          newMarker.on('mouseout', function() {
            infoWindow1.close();
          });
          //绘制安吉国控点凤凰山水库大坝选择半径的圆形
          const circle1 = new AMap.Circle({
            center: [119.701200,30.595802],
            radius: this.AnjiKMValue, // this.AnjiKMValue是topHeader选择的国控点范围
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circle1.setMap(this.aliMap);
          this.currentCircle.push(circle1);
          // 新增的固定点位 安吉县实验小学（玉华校区）
          const newMarker1 = new AMap.Marker({
            text:'安吉县实验小学(玉华校区)',
            position: [119.690545,30.636576],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',//设置地图标记的锚点位置
            offset: new AMap.Pixel(0, 0),//设置图标的偏移量，加入上面这两个即可解决地图缩放标记点不在圆心的问题
            zIndex: 1
          })
          newMarker1.setMap(that.aliMap)
          // 创建信息窗口
          const infoWindow2 = new AMap.InfoWindow({
            isCustom: true,// 禁用默认样式
            content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:300rem;">
                  <p>
                  <span style="color:#c7c7cc">安吉县实验小学(玉华校区)${this.AnjiKMValue}米点位信息:</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">餐饮店：</span>
                  <span style="color:#c7c7cc">${this.showOneKM.point2.Management}家</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">机关食堂：</span>
                  <span style="color:#c7c7cc">${this.showOneKM.point2.notManagement}家</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">在线监测点：</span>
                  <span style="color:#c7c7cc">${this.showOneKM.point2.onlineStatus}家</span>
                  </p>
                </div>
              `, // 信息窗口的内容
            offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
          });
          // 绑定点击事件
          newMarker1.on('mouseover', function() {
            infoWindow2.open(that.aliMap, newMarker1.getPosition());
          });
          // 绑定鼠标移出事件，关闭信息窗口
          newMarker1.on('mouseout', function() {
            infoWindow2.close();
          });
          //绘制安吉国控点安吉县实验小学（玉华校区）选择半径的圆形
          const circle2 = new AMap.Circle({
            center: [119.690545,30.636576],
            radius: this.AnjiKMValue, // this.AnjiKMValue是topHeader选择的国控点范围
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circle2.setMap(this.aliMap);
          this.currentCircle.push(circle2);
        // })

      }
      //下面是成都的
      if(accountUser.Info && accountUser.Info.pid && accountUser.Info.pid.slice(0,6) == "/1199/"){
        // console.log('执行第一个if')
        // 高新南区新增三瓦窑固定点位                                              锦江区                                 双流区
        if(this.contentData.code === "gxnq" || this.contentData.code === "510104" || this.contentData.code === "510116" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker1 = new AMap.Marker({
            position: [104.061654,30.574659],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',//设置地图标记的锚点位置
            offset: new AMap.Pixel(0, 0),//设置图标的偏移量，加入上面这两个即可解决地图缩放标记点不在圆心的问题
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          });
          // 创建文本标签
          this.fixedMarkerLable('三瓦窑',[104.061654,30.574659],[-22, 15])
          // 绘制三瓦窑半径为1公里的圆
          const circle1 = new AMap.Circle({
            center: [104.061654,30.574659],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circle1.setMap(this.aliMap);
          // 绘制三瓦窑半径为3公里的圆
          const circle3 = new AMap.Circle({
            center: [104.061654,30.574659],
            radius: 3000, // 半径3公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circle3.setMap(this.aliMap);
          // 绘制(三瓦窑的核心区域)
          this.fixedPolygon(sanwayao1Km)
          // 绘制(三瓦窑的重点区域)
          this.fixedPolygon(sanwayao3Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "gxnq"){
            const infoWindowsanwayao = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.green + this.GKDData['武侯区三瓦窑重点区域'].GXNQ.red+this.GKDData['武侯区三瓦窑重点区域'].GXNQ.grey+this.GKDData['武侯区三瓦窑重点区域'].GXNQ.black}个点位，达标${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.green}个，超标${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.red}个，正常离线${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.grey}个，异常离线${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.green + this.GKDData['武侯区三瓦窑核心区域'].GXNQ.red+this.GKDData['武侯区三瓦窑核心区域'].GXNQ.grey+this.GKDData['武侯区三瓦窑核心区域'].GXNQ.black}个点位，达标${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.green}个，超标${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.red}个，正常离线${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.grey}个，异常离线${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker1.on('mouseover', function() {
              infoWindowsanwayao.open(that.aliMap, newMarker1.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker1.on('mouseout', function() {
              infoWindowsanwayao.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowsanwayao = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.green + this.GKDData['武侯区三瓦窑重点区域'].GXNQ.red+this.GKDData['武侯区三瓦窑重点区域'].GXNQ.grey+this.GKDData['武侯区三瓦窑重点区域'].GXNQ.black}个点位，达标${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.green}个，超标${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.red}个，正常离线${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.grey}个，异常离线${this.GKDData['武侯区三瓦窑重点区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['武侯区三瓦窑重点区域'].WHQ.green + this.GKDData['武侯区三瓦窑重点区域'].WHQ.red+this.GKDData['武侯区三瓦窑重点区域'].WHQ.grey+this.GKDData['武侯区三瓦窑重点区域'].WHQ.black}个点位，达标${this.GKDData['武侯区三瓦窑重点区域'].WHQ.green}个，超标${this.GKDData['武侯区三瓦窑重点区域'].WHQ.red}个，正常离线${this.GKDData['武侯区三瓦窑重点区域'].WHQ.grey}个，异常离线${this.GKDData['武侯区三瓦窑重点区域'].WHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.green + this.GKDData['武侯区三瓦窑核心区域'].GXNQ.red+this.GKDData['武侯区三瓦窑核心区域'].GXNQ.grey+this.GKDData['武侯区三瓦窑核心区域'].GXNQ.black}个点位，达标${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.green}个，超标${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.red}个，正常离线${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.grey}个，异常离线${this.GKDData['武侯区三瓦窑核心区域'].GXNQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker1.on('mouseover', function() {
              infoWindowsanwayao.open(that.aliMap, newMarker1.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker1.on('mouseout', function() {
              infoWindowsanwayao.close();
            });
          }

          //锦江区看到该国控点的数据
          if(this.contentData.code === "510104"){
            const infoWindowsanwayao = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker1.on('mouseover', function() {
              infoWindowsanwayao.open(that.aliMap, newMarker1.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker1.on('mouseout', function() {
              infoWindowsanwayao.close();
            });
          }

          //双流区看到该国控点的数据
          if(this.contentData.code === "510116"){
            const infoWindowsanwayao = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker1.on('mouseover', function() {
              infoWindowsanwayao.open(that.aliMap, newMarker1.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker1.on('mouseout', function() {
              infoWindowsanwayao.close();
            });
          }

        }

        // 锦江区新增沙河铺固定点位                                              武侯区                                成华区                                  龙泉驿区
        if(this.contentData.code === "510104" || this.contentData.code === "510107" || this.contentData.code === "510108" || this.contentData.code === "510112"|| (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker2 = new AMap.Marker({
            position: [104.114389,30.628485],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('沙河铺',[104.114389,30.628485],[-24, 15])
          // 绘制沙河铺半径为1公里的圆
          const circleshahepu1 = new AMap.Circle({
            center: [104.114389,30.628485],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleshahepu1.setMap(this.aliMap);
          // 绘制沙河铺半径为3公里的圆
          const circleshahepu3 = new AMap.Circle({
            center: [104.114389,30.628485],
            radius: 3000, // 半径3公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleshahepu3.setMap(this.aliMap);
          // 绘制(沙河铺的核心区域)
          this.fixedPolygon(shahepu1Km)
          // 绘制(沙河铺的重点区域)
          this.fixedPolygon(shahepu3Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "510104"){
            const infoWindowshahepu = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">锦江区，${this.GKDData['锦江区沙河铺重点区域'].JJQ.green + this.GKDData['锦江区沙河铺重点区域'].JJQ.red+this.GKDData['锦江区沙河铺重点区域'].JJQ.grey+this.GKDData['锦江区沙河铺重点区域'].JJQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].JJQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].JJQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].JJQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].JJQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">锦江区，${this.GKDData['锦江区沙河铺核心区域'].JJQ.green + this.GKDData['锦江区沙河铺核心区域'].JJQ.red+this.GKDData['锦江区沙河铺核心区域'].JJQ.grey+this.GKDData['锦江区沙河铺核心区域'].JJQ.black}个点位，达标${this.GKDData['锦江区沙河铺核心区域'].JJQ.green}个，超标${this.GKDData['锦江区沙河铺核心区域'].JJQ.red}个，正常离线${this.GKDData['锦江区沙河铺核心区域'].JJQ.grey}个，异常离线${this.GKDData['锦江区沙河铺核心区域'].JJQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker2.on('mouseover', function() {
              infoWindowshahepu.open(that.aliMap, newMarker2.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker2.on('mouseout', function() {
              infoWindowshahepu.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowshahepu = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">成华区，${this.GKDData['锦江区沙河铺重点区域'].CHQ.green + this.GKDData['锦江区沙河铺重点区域'].CHQ.red+this.GKDData['锦江区沙河铺重点区域'].CHQ.grey+this.GKDData['锦江区沙河铺重点区域'].CHQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].CHQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].CHQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].CHQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].CHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['锦江区沙河铺重点区域'].GXNQ.green + this.GKDData['锦江区沙河铺重点区域'].GXNQ.red+this.GKDData['锦江区沙河铺重点区域'].GXNQ.grey+this.GKDData['锦江区沙河铺重点区域'].GXNQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].GXNQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].GXNQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].GXNQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">锦江区，${this.GKDData['锦江区沙河铺重点区域'].JJQ.green + this.GKDData['锦江区沙河铺重点区域'].JJQ.red+this.GKDData['锦江区沙河铺重点区域'].JJQ.grey+this.GKDData['锦江区沙河铺重点区域'].JJQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].JJQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].JJQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].JJQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].JJQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['锦江区沙河铺重点区域'].WHQ.green + this.GKDData['锦江区沙河铺重点区域'].WHQ.red+this.GKDData['锦江区沙河铺重点区域'].WHQ.grey+this.GKDData['锦江区沙河铺重点区域'].WHQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].WHQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].WHQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].WHQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].WHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">锦江区，${this.GKDData['锦江区沙河铺核心区域'].JJQ.green + this.GKDData['锦江区沙河铺核心区域'].JJQ.red+this.GKDData['锦江区沙河铺核心区域'].JJQ.grey+this.GKDData['锦江区沙河铺核心区域'].JJQ.black}个点位，达标${this.GKDData['锦江区沙河铺核心区域'].JJQ.green}个，超标${this.GKDData['锦江区沙河铺核心区域'].JJQ.red}个，正常离线${this.GKDData['锦江区沙河铺核心区域'].JJQ.grey}个,异常离线${this.GKDData['锦江区沙河铺核心区域'].JJQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker2.on('mouseover', function() {
              infoWindowshahepu.open(that.aliMap, newMarker2.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker2.on('mouseout', function() {
              infoWindowshahepu.close();
            });
          }

          //武侯区看到该国控点的数据
          if(this.contentData.code === "510107"){
            const infoWindowshahepu = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['锦江区沙河铺重点区域'].WHQ.green + this.GKDData['锦江区沙河铺重点区域'].WHQ.red+this.GKDData['锦江区沙河铺重点区域'].WHQ.grey+this.GKDData['锦江区沙河铺重点区域'].WHQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].WHQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].WHQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].WHQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].WHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker2.on('mouseover', function() {
              infoWindowshahepu.open(that.aliMap, newMarker2.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker2.on('mouseout', function() {
              infoWindowshahepu.close();
            });
          }

          //成华区看到该国控点的数据
          if(this.contentData.code === "510108"){
            const infoWindowshahepu = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">成华区，${this.GKDData['锦江区沙河铺重点区域'].CHQ.green + this.GKDData['锦江区沙河铺重点区域'].CHQ.red+this.GKDData['锦江区沙河铺重点区域'].CHQ.grey+this.GKDData['锦江区沙河铺重点区域'].CHQ.black}个点位，达标${this.GKDData['锦江区沙河铺重点区域'].CHQ.green}个，超标${this.GKDData['锦江区沙河铺重点区域'].CHQ.red}个，正常离线${this.GKDData['锦江区沙河铺重点区域'].CHQ.grey}个，异常离线${this.GKDData['锦江区沙河铺重点区域'].CHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker2.on('mouseover', function() {
              infoWindowshahepu.open(that.aliMap, newMarker2.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker2.on('mouseout', function() {
              infoWindowshahepu.close();
            });
          }

          //龙泉驿区看到该国控点的数据
          if(this.contentData.code === "510112"){
            const infoWindowshahepu = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker2.on('mouseover', function() {
              infoWindowshahepu.open(that.aliMap, newMarker2.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker2.on('mouseout', function() {
              infoWindowshahepu.close();
            });
          }

        }

        // 青羊区新增大石西路和君平街固定点位                                      武侯区
        if(this.contentData.code === "510105" || this.contentData.code === "510107" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker3 = new AMap.Marker({
            position: [104.024046,30.653211],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('大石西路',[104.024046,30.653211],[-32, 15])
          // 绘制大石西路半径为1公里的圆
          const circledashi1 = new AMap.Circle({
            center: [104.024046,30.653211],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circledashi1.setMap(this.aliMap);
          // 绘制大石西路半径为3公里的圆
          const circledashi3 = new AMap.Circle({
            center: [104.024046,30.653211],
            radius: 3000, // 半径3公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circledashi3.setMap(this.aliMap);
          // 新增君平街固定点位
          const newMarker4 = new AMap.Marker({
            position: [104.045543,30.65277],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('君平街',[104.045543,30.65277],[-24, 15])
          // 绘制君平街半径为1公里的圆
          const circlejunping1 = new AMap.Circle({
            center: [104.045543,30.65277],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlejunping1.setMap(this.aliMap);
          // 绘制君平街半径为3公里的圆
          const circlejunping3 = new AMap.Circle({
            center: [104.045543,30.65277],
            radius: 3000, // 半径3公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlejunping3.setMap(this.aliMap);
          // 绘制(大石西路和君平街的核心区域)
          this.fixedPolygon(dashi1Km)
          // 绘制(大石西路和君平街的重点区域)
          this.fixedPolygon(dashi3Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "510105"){
            const infoWindowdashi = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker3.on('mouseover', function() {
              infoWindowdashi.open(that.aliMap, newMarker3.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker3.on('mouseout', function() {
              infoWindowdashi.close();
            });
            // 鼠标悬停窗口
            const infoWindowjunping = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker4.on('mouseover', function() {
              infoWindowjunping.open(that.aliMap, newMarker4.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker4.on('mouseout', function() {
              infoWindowjunping.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowdashi = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker3.on('mouseover', function() {
              infoWindowdashi.open(that.aliMap, newMarker3.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker3.on('mouseout', function() {
              infoWindowdashi.close();
            });
            // 鼠标悬停窗口
            const infoWindowjunping = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].JNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.red}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker4.on('mouseover', function() {
              infoWindowjunping.open(that.aliMap, newMarker4.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker4.on('mouseout', function() {
              infoWindowjunping.close();
            });
          }

          //武侯区看到该国控点的数据
          if(this.contentData.code === "510107"){
            const infoWindowdashi = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].WHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">武侯区，${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].WHQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker3.on('mouseover', function() {
              infoWindowdashi.open(that.aliMap, newMarker3.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker3.on('mouseout', function() {
              infoWindowdashi.close();
            });
            // 鼠标悬停窗口
            const infoWindowjunping = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green + this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey+this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个点位，达标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.green}个，超标${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.red}个，正常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.grey}个，异常离线${this.GKDData['青羊区大石西路和君平街核心区域'].QYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker4.on('mouseover', function() {
              infoWindowjunping.open(that.aliMap, newMarker4.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker4.on('mouseout', function() {
              infoWindowjunping.close();
            });
          }

        }

        // 成华区新增十里店固定点位                                             龙泉驿区
        if(this.contentData.code === "510108" || this.contentData.code === "510112" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker5 = new AMap.Marker({
            position: [104.144451,30.673983],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('十里店',[104.144451,30.673983],[-24, 15])
          // 绘制十里店半径为1公里的圆
          const circleshili1 = new AMap.Circle({
            center: [104.144451,30.673983],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleshili1.setMap(this.aliMap);
          // 绘制十里店半径为3公里的圆
          const circleshili3 = new AMap.Circle({
            center: [104.144451,30.673983],
            radius: 3000, // 半径3公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleshili3.setMap(this.aliMap);
          // 绘制(十里店核心区域)
          this.fixedPolygon(shili1Km)
          // 绘制(十里店的重点区域)
          this.fixedPolygon(shili3Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "510108"){
            const infoWindowshili = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">成华区，${this.GKDData['成华区十里店重点区域'].CHQ.green + this.GKDData['成华区十里店重点区域'].CHQ.red+this.GKDData['成华区十里店重点区域'].CHQ.grey+this.GKDData['成华区十里店重点区域'].CHQ.black}个点位，达标${this.GKDData['成华区十里店重点区域'].CHQ.green}个，超标${this.GKDData['成华区十里店重点区域'].CHQ.red}个，正常离线${this.GKDData['成华区十里店重点区域'].CHQ.grey}个，异常离线${this.GKDData['成华区十里店重点区域'].CHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">成华区，${this.GKDData['成华区十里店核心区域'].CHQ.green + this.GKDData['成华区十里店核心区域'].CHQ.red+this.GKDData['成华区十里店核心区域'].CHQ.grey+this.GKDData['成华区十里店核心区域'].CHQ.black}个点位，达标${this.GKDData['成华区十里店核心区域'].CHQ.green}个，超标${this.GKDData['成华区十里店核心区域'].CHQ.red}个，正常离线${this.GKDData['成华区十里店核心区域'].CHQ.grey}个，异常离线${this.GKDData['成华区十里店核心区域'].CHQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker5.on('mouseover', function() {
              infoWindowshili.open(that.aliMap, newMarker5.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker5.on('mouseout', function() {
              infoWindowshili.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowshili = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">成华区，${this.GKDData['成华区十里店重点区域'].CHQ.green + this.GKDData['成华区十里店重点区域'].CHQ.red+this.GKDData['成华区十里店重点区域'].CHQ.grey+this.GKDData['成华区十里店重点区域'].CHQ.black}个点位，达标${this.GKDData['成华区十里店重点区域'].CHQ.green}个，超标${this.GKDData['成华区十里店重点区域'].CHQ.red}个，正常离线${this.GKDData['成华区十里店重点区域'].CHQ.grey}个，异常离线${this.GKDData['成华区十里店重点区域'].CHQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['成华区十里店重点区域'].LQYQ.green + this.GKDData['成华区十里店重点区域'].LQYQ.red+this.GKDData['成华区十里店重点区域'].LQYQ.grey+this.GKDData['成华区十里店重点区域'].LQYQ.black}个点位，达标${this.GKDData['成华区十里店重点区域'].LQYQ.green}个，超标${this.GKDData['成华区十里店重点区域'].LQYQ.red}个，正常离线${this.GKDData['成华区十里店重点区域'].LQYQ.grey}个，异常离线${this.GKDData['成华区十里店重点区域'].LQYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">成华区，${this.GKDData['成华区十里店核心区域'].CHQ.green + this.GKDData['成华区十里店核心区域'].CHQ.red+this.GKDData['成华区十里店核心区域'].CHQ.grey+this.GKDData['成华区十里店核心区域'].CHQ.black}个点位，达标${this.GKDData['成华区十里店核心区域'].CHQ.green}个，超标${this.GKDData['成华区十里店核心区域'].CHQ.red}个，正常离线${this.GKDData['成华区十里店核心区域'].CHQ.grey}个，异常离线${this.GKDData['成华区十里店核心区域'].CHQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker5.on('mouseover', function() {
              infoWindowshili.open(that.aliMap, newMarker5.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker5.on('mouseout', function() {
              infoWindowshili.close();
            });
          }

          //龙泉驿区看到该国控点的数据
          if(this.contentData.code === "510112"){
            const infoWindowshili = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['成华区十里店重点区域'].LQYQ.green + this.GKDData['成华区十里店重点区域'].LQYQ.red+this.GKDData['成华区十里店重点区域'].LQYQ.grey+this.GKDData['成华区十里店重点区域'].LQYQ.black}个点位，达标${this.GKDData['成华区十里店重点区域'].LQYQ.green}个，超标${this.GKDData['成华区十里店重点区域'].LQYQ.red}个，正常离线${this.GKDData['成华区十里店重点区域'].LQYQ.grey}个，异常离线${this.GKDData['成华区十里店重点区域'].LQYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker5.on('mouseover', function() {
              infoWindowshili.open(that.aliMap, newMarker5.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker5.on('mouseout', function() {
              infoWindowshili.close();
            });
          }


        }

        // 金牛区新增金博路固定点位                                              青羊区
        if(this.contentData.code === "510106" || this.contentData.code === "510105" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker6 = new AMap.Marker({
            position: [104.0129,30.69248],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('金博路',[104.0129,30.69248],[-24, 15])
          // 绘制金博路半径为1公里的圆
          const circlejinbo1 = new AMap.Circle({
            center: [104.0129,30.69248],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlejinbo1.setMap(this.aliMap);
          // 绘制金博路半径为3公里的圆
          const circlejinbo3 = new AMap.Circle({
            center: [104.0129,30.69248],
            radius: 3000, // 半径3公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlejinbo3.setMap(this.aliMap);
          // 绘制(金博路核心区域)
          this.fixedPolygon(jinbo1Km)
          // 绘制(金博路的重点区域)
          this.fixedPolygon(jinbo3Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "510106"){
            const infoWindowjinbo = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['金牛区金博路重点区域'].JNQ.green + this.GKDData['金牛区金博路重点区域'].JNQ.red+this.GKDData['金牛区金博路重点区域'].JNQ.grey+this.GKDData['金牛区金博路重点区域'].JNQ.black}个点位，达标${this.GKDData['金牛区金博路重点区域'].JNQ.green}个，超标${this.GKDData['金牛区金博路重点区域'].JNQ.red}个，正常离线${this.GKDData['金牛区金博路重点区域'].JNQ.grey}个，异常离线${this.GKDData['金牛区金博路重点区域'].JNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['金牛区金博路核心区域'].JNQ.green + this.GKDData['金牛区金博路核心区域'].JNQ.red+this.GKDData['金牛区金博路核心区域'].JNQ.grey+this.GKDData['金牛区金博路核心区域'].JNQ.black}个点位，达标${this.GKDData['金牛区金博路核心区域'].JNQ.green}个，超标${this.GKDData['金牛区金博路核心区域'].JNQ.red}个，正常离线${this.GKDData['金牛区金博路核心区域'].JNQ.grey}个，异常离线${this.GKDData['金牛区金博路核心区域'].JNQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker6.on('mouseover', function() {
              infoWindowjinbo.open(that.aliMap, newMarker6.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker6.on('mouseout', function() {
              infoWindowjinbo.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowjinbo = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['金牛区金博路重点区域'].JNQ.green + this.GKDData['金牛区金博路重点区域'].JNQ.red+this.GKDData['金牛区金博路重点区域'].JNQ.grey+this.GKDData['金牛区金博路重点区域'].JNQ.black}个点位，达标${this.GKDData['金牛区金博路重点区域'].JNQ.green}个，超标${this.GKDData['金牛区金博路重点区域'].JNQ.red}个，正常离线${this.GKDData['金牛区金博路重点区域'].JNQ.grey}个，异常离线${this.GKDData['金牛区金博路重点区域'].JNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['金牛区金博路重点区域'].QYQ.green + this.GKDData['金牛区金博路重点区域'].QYQ.red+this.GKDData['金牛区金博路重点区域'].QYQ.grey+this.GKDData['金牛区金博路重点区域'].QYQ.black}个点位，达标${this.GKDData['金牛区金博路重点区域'].QYQ.green}个，超标${this.GKDData['金牛区金博路重点区域'].QYQ.red}个，正常离线${this.GKDData['金牛区金博路重点区域'].QYQ.grey}个，异常离线${this.GKDData['金牛区金博路重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['金牛区金博路核心区域'].JNQ.green + this.GKDData['金牛区金博路核心区域'].JNQ.red+this.GKDData['金牛区金博路核心区域'].JNQ.grey+this.GKDData['金牛区金博路核心区域'].JNQ.black}个点位，达标${this.GKDData['金牛区金博路核心区域'].JNQ.green}个，超标${this.GKDData['金牛区金博路核心区域'].JNQ.red}个，正常离线${this.GKDData['金牛区金博路核心区域'].JNQ.grey}个，异常离线${this.GKDData['金牛区金博路核心区域'].JNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['金牛区金博路核心区域'].QYQ.green + this.GKDData['金牛区金博路核心区域'].QYQ.red+this.GKDData['金牛区金博路核心区域'].QYQ.grey+this.GKDData['金牛区金博路核心区域'].QYQ.black}个点位，达标${this.GKDData['金牛区金博路核心区域'].QYQ.green}个，超标${this.GKDData['金牛区金博路核心区域'].QYQ.red}个，正常离线${this.GKDData['金牛区金博路核心区域'].QYQ.grey}个，异常离线${this.GKDData['金牛区金博路核心区域'].QYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker6.on('mouseover', function() {
              infoWindowjinbo.open(that.aliMap, newMarker6.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker6.on('mouseout', function() {
              infoWindowjinbo.close();
            });
          }

          //青羊区查看到该国控点的数据
          if(this.contentData.code === "510105"){
            const infoWindowjinbo = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['金牛区金博路重点区域'].QYQ.green + this.GKDData['金牛区金博路重点区域'].QYQ.red+this.GKDData['金牛区金博路重点区域'].QYQ.grey+this.GKDData['金牛区金博路重点区域'].QYQ.black}个点位，达标${this.GKDData['金牛区金博路重点区域'].QYQ.green}个，超标${this.GKDData['金牛区金博路重点区域'].QYQ.red}个，正常离线${this.GKDData['金牛区金博路重点区域'].QYQ.grey}个，异常离线${this.GKDData['金牛区金博路重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['金牛区金博路核心区域'].QYQ.green + this.GKDData['金牛区金博路核心区域'].QYQ.red+this.GKDData['金牛区金博路核心区域'].QYQ.grey+this.GKDData['金牛区金博路核心区域'].QYQ.black}个点位，达标${this.GKDData['金牛区金博路核心区域'].QYQ.green}个，超标${this.GKDData['金牛区金博路核心区域'].QYQ.red}个，正常离线${this.GKDData['金牛区金博路核心区域'].QYQ.grey}个，异常离线${this.GKDData['金牛区金博路核心区域'].QYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker6.on('mouseover', function() {
              infoWindowjinbo.open(that.aliMap, newMarker6.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker6.on('mouseout', function() {
              infoWindowjinbo.close();
            });
          }

        }

        // 郫都区新增金泉两河固定点位                                            温江区                                 青羊区
        if(this.contentData.code === "gxnq" || this.contentData.code === "510117" || this.contentData.code === "510115" || this.contentData.code === "510105" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker7 = new AMap.Marker({
            position: [103.975195,30.720638],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('金泉两河',[103.975195,30.720638],[-32, 15])
          // 绘制金泉两河半径为1公里的圆
          const circlejinquanlianghe1 = new AMap.Circle({
            center: [103.975195,30.720638],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlejinquanlianghe1.setMap(this.aliMap);
          // 绘制金泉两河半径为5公里的圆
          const circlejinquanlianghe3 = new AMap.Circle({
            center: [103.975195,30.720638],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlejinquanlianghe3.setMap(this.aliMap);
          // 绘制(金泉两河核心区域)
          this.fixedPolygon(jinquanlianghe1Km)
          // 绘制(金泉两河的重点区域)
          this.fixedPolygon(jinquanlianghe3Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "510117"){
            const infoWindowjinquanlianghe = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">郫都区，${this.GKDData['郫都区金泉两河重点区域'].PDQ.green + this.GKDData['郫都区金泉两河重点区域'].PDQ.red+this.GKDData['郫都区金泉两河重点区域'].PDQ.grey+this.GKDData['郫都区金泉两河重点区域'].PDQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].PDQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].PDQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].PDQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].PDQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker7.on('mouseover', function() {
              infoWindowjinquanlianghe.open(that.aliMap, newMarker7.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker7.on('mouseout', function() {
              infoWindowjinquanlianghe.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowjinquanlianghe = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['郫都区金泉两河重点区域'].GXNQ.green + this.GKDData['郫都区金泉两河重点区域'].GXNQ.red+this.GKDData['郫都区金泉两河重点区域'].GXNQ.grey+this.GKDData['郫都区金泉两河重点区域'].GXNQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].GXNQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].GXNQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].GXNQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['郫都区金泉两河重点区域'].JNQ.green + this.GKDData['郫都区金泉两河重点区域'].JNQ.red+this.GKDData['郫都区金泉两河重点区域'].JNQ.grey+this.GKDData['郫都区金泉两河重点区域'].JNQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].JNQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].JNQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].JNQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].JNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">郫都区，${this.GKDData['郫都区金泉两河重点区域'].PDQ.green + this.GKDData['郫都区金泉两河重点区域'].PDQ.red+this.GKDData['郫都区金泉两河重点区域'].PDQ.grey+this.GKDData['郫都区金泉两河重点区域'].PDQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].PDQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].PDQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].PDQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].PDQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['郫都区金泉两河重点区域'].QYQ.green + this.GKDData['郫都区金泉两河重点区域'].QYQ.red+this.GKDData['郫都区金泉两河重点区域'].QYQ.grey+this.GKDData['郫都区金泉两河重点区域'].QYQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].QYQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].QYQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].QYQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['郫都区金泉两河核心区域'].GXNQ.green + this.GKDData['郫都区金泉两河核心区域'].GXNQ.red+this.GKDData['郫都区金泉两河核心区域'].GXNQ.grey+this.GKDData['郫都区金泉两河核心区域'].GXNQ.black}个点位，达标${this.GKDData['郫都区金泉两河核心区域'].GXNQ.green}个，超标${this.GKDData['郫都区金泉两河核心区域'].GXNQ.red}个，正常离线${this.GKDData['郫都区金泉两河核心区域'].GXNQ.grey}个，异常离线${this.GKDData['郫都区金泉两河核心区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">金牛区，${this.GKDData['郫都区金泉两河核心区域'].JNQ.green + this.GKDData['郫都区金泉两河核心区域'].JNQ.red+this.GKDData['郫都区金泉两河核心区域'].JNQ.grey+this.GKDData['郫都区金泉两河核心区域'].JNQ.black}个点位，达标${this.GKDData['郫都区金泉两河核心区域'].JNQ.green}个，超标${this.GKDData['郫都区金泉两河核心区域'].JNQ.red}个，正常离线${this.GKDData['郫都区金泉两河核心区域'].JNQ.grey}个，异常离线${this.GKDData['郫都区金泉两河核心区域'].JNQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker7.on('mouseover', function() {
              infoWindowjinquanlianghe.open(that.aliMap, newMarker7.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker7.on('mouseout', function() {
              infoWindowjinquanlianghe.close();
            });

          }

          //温江区登录看到该国控点的数据
          if(this.contentData.code === "510115"){
            const infoWindowjinquanlianghe = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker7.on('mouseover', function() {
              infoWindowjinquanlianghe.open(that.aliMap, newMarker7.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker7.on('mouseout', function() {
              infoWindowjinquanlianghe.close();
            });
          }

          //青羊区看到该国控点的数据
          if(this.contentData.code === "510105"){
            const infoWindowjinquanlianghe = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                 <span style="color:#c7c7cc">青羊区，${this.GKDData['郫都区金泉两河重点区域'].QYQ.green + this.GKDData['郫都区金泉两河重点区域'].QYQ.red+this.GKDData['郫都区金泉两河重点区域'].QYQ.grey+this.GKDData['郫都区金泉两河重点区域'].QYQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].QYQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].QYQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].QYQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker7.on('mouseover', function() {
              infoWindowjinquanlianghe.open(that.aliMap, newMarker7.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker7.on('mouseout', function() {
              infoWindowjinquanlianghe.close();
            });
          }

          //高新南区看到的数据
          if(this.contentData.code === "gxnq"){
            const infoWindowjinquanlianghe = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['郫都区金泉两河重点区域'].GXNQ.green + this.GKDData['郫都区金泉两河重点区域'].GXNQ.red+this.GKDData['郫都区金泉两河重点区域'].GXNQ.grey+this.GKDData['郫都区金泉两河重点区域'].GXNQ.black}个点位，达标${this.GKDData['郫都区金泉两河重点区域'].GXNQ.green}个，超标${this.GKDData['郫都区金泉两河重点区域'].GXNQ.red}个，正常离线${this.GKDData['郫都区金泉两河重点区域'].GXNQ.grey}个，异常离线${this.GKDData['郫都区金泉两河重点区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['郫都区金泉两河核心区域'].GXNQ.green + this.GKDData['郫都区金泉两河核心区域'].GXNQ.red+this.GKDData['郫都区金泉两河核心区域'].GXNQ.grey+this.GKDData['郫都区金泉两河核心区域'].GXNQ.black}个点位，达标${this.GKDData['郫都区金泉两河核心区域'].GXNQ.green}个，超标${this.GKDData['郫都区金泉两河核心区域'].GXNQ.red}个，正常离线${this.GKDData['郫都区金泉两河核心区域'].GXNQ.grey}个，异常离线${this.GKDData['郫都区金泉两河核心区域'].GXNQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker7.on('mouseover', function() {
              infoWindowjinquanlianghe.open(that.aliMap, newMarker7.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker7.on('mouseout', function() {
              infoWindowjinquanlianghe.close();
            });

          }

        }

        // 龙泉驿区新增车城东七路和龙泉驿区政府固定点位                              双流区
        if(this.contentData.code === "510112" || this.contentData.code === "510116" || this.contentData.code === "tfxq" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker8 = new AMap.Marker({
            position: [104.242614,30.52802],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('车城东七路',[104.242614,30.52802],[-39, 15])
          // 绘制车城东七路半径为1公里的圆
          const circlechechengdong1 = new AMap.Circle({
            center: [104.242614,30.52802],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlechechengdong1.setMap(this.aliMap);
          // 绘制车城东七路半径为5公里的圆
          const circlechechengdong5 = new AMap.Circle({
            center: [104.242614,30.52802],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlechechengdong5.setMap(this.aliMap);
          // 新增龙泉驿区政府固定点位
          const newMarker9 = new AMap.Marker({
            position: [104.274919,30.556725],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('龙泉驿区政府',[104.274919,30.556725],[-45, 15])
          // 绘制龙泉驿区政府半径为1公里的圆
          const circlelongquan1 = new AMap.Circle({
            center: [104.274919,30.556725],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlelongquan1.setMap(this.aliMap);
          // 绘制龙泉驿区政府半径为5公里的圆
          const circlelongquan5 = new AMap.Circle({
            center: [104.274919,30.556725],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlelongquan5.setMap(this.aliMap);
          // 绘制(车城东七路和龙泉驿区政府核心区域)
          this.fixedPolygon(longquan1Km)
          // 绘制(金车城东七路和龙泉驿区政府的重点区域)
          this.fixedPolygon(longquan5Km)
          // 鼠标悬停窗口
          if(this.contentData.code === "510112"){
            const infoWindowchechengdong = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker8.on('mouseover', function() {
              infoWindowchechengdong.open(that.aliMap, newMarker8.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker8.on('mouseout', function() {
              infoWindowchechengdong.close();
            });
            // 鼠标悬停窗口
            const infoWindowlongquan = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                 <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker9.on('mouseover', function() {
              infoWindowlongquan.open(that.aliMap, newMarker9.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker9.on('mouseout', function() {
              infoWindowlongquan.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowchechengdong = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker8.on('mouseover', function() {
              infoWindowchechengdong.open(that.aliMap, newMarker8.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker8.on('mouseout', function() {
              infoWindowchechengdong.close();
            });
            // 鼠标悬停窗口
            const infoWindowlongquan = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                 <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府重点区域'].LQYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">龙泉驿区，${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green + this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey+this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个点位，达标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.green}个，超标${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.red}个，正常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.grey}个，异常离线${this.GKDData['龙泉驿区车城东七路和龙泉驿区政府核心区域'].LQYQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker9.on('mouseover', function() {
              infoWindowlongquan.open(that.aliMap, newMarker9.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker9.on('mouseout', function() {
              infoWindowlongquan.close();
            });
          }

          //展示双流区看到该国控点的统计信息
          if(this.contentData.code === "510116" || this.contentData.code === "tfxq"){
            const infoWindowchechengdong = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker8.on('mouseover', function() {
              infoWindowchechengdong.open(that.aliMap, newMarker8.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker8.on('mouseout', function() {
              infoWindowchechengdong.close();
            });
            // 鼠标悬停窗口
            const infoWindowlongquan = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                 <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker9.on('mouseover', function() {
              infoWindowlongquan.open(that.aliMap, newMarker9.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker9.on('mouseout', function() {
              infoWindowlongquan.close();
            });
          }


        }

        // 天府新区新增科学城和华阳固定点位                                       双流区
        if(this.contentData.code === "tfxq" || this.contentData.code === "510116" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker10 = new AMap.Marker({
            position: [104.080174,30.404134],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('科学城',[104.080174,30.404134],[-24, 15])
          // 绘制科学城半径为1公里的圆
          const circlekexuecheng1 = new AMap.Circle({
            center: [104.080174,30.404134],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlekexuecheng1.setMap(this.aliMap);
          // 绘制科学城半径为5公里的圆
          const circlekexuehceng5 = new AMap.Circle({
            center: [104.080174,30.404134],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlekexuehceng5.setMap(this.aliMap);
          // 绘制(科学城核心区域)
          this.fixedPolygon(kexuecheng1Km)
          // 绘制(科学城的重点区域)
          this.fixedPolygon(kexuecheng3Km)
          // 新增华阳固定点位
          const newMarker11 = new AMap.Marker({
            position: [104.059902,30.520502],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('华阳',[104.059902,30.520502],[-18, 15])
          // 绘制华阳半径为1公里的圆
          const circlehuayang1 = new AMap.Circle({
            center: [104.059902,30.520502],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlehuayang1.setMap(this.aliMap);
          // 绘制华阳半径为5公里的圆
          const circlehuayang5 = new AMap.Circle({
            center: [104.059902,30.520502],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circlehuayang5.setMap(this.aliMap);
          // 绘制(华阳核心区域)
          this.fixedPolygon(huayang1Km)
          // 绘制(华阳的重点区域)
          this.fixedPolygon(huayang3Km)
          // 鼠标悬停窗口  天府新区查看
          if(this.contentData.code === "tfxq"){
            const infoWindowkexuecheng = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区科学城重点区域'].TFXQ.green + this.GKDData['双流区科学城重点区域'].TFXQ.red+this.GKDData['双流区科学城重点区域'].TFXQ.grey+this.GKDData['双流区科学城重点区域'].TFXQ.black}个点位，达标${this.GKDData['双流区科学城重点区域'].TFXQ.green}个，超标${this.GKDData['双流区科学城重点区域'].TFXQ.red}个，正常离线${this.GKDData['双流区科学城重点区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区科学城重点区域'].TFXQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                 <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区科学城核心区域'].TFXQ.green + this.GKDData['双流区科学城核心区域'].TFXQ.red+this.GKDData['双流区科学城核心区域'].TFXQ.grey+this.GKDData['双流区科学城核心区域'].TFXQ.black}个点位，达标${this.GKDData['双流区科学城核心区域'].TFXQ.green}个，超标${this.GKDData['双流区科学城核心区域'].TFXQ.red}个，正常离线${this.GKDData['双流区科学城核心区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区科学城核心区域'].TFXQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker10.on('mouseover', function() {
              infoWindowkexuecheng.open(that.aliMap, newMarker10.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker10.on('mouseout', function() {
              infoWindowkexuecheng.close();
            });
            // 鼠标悬停窗口
            const infoWindowhuayang = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区华阳重点区域'].TFXQ.green + this.GKDData['双流区华阳重点区域'].TFXQ.red+this.GKDData['双流区华阳重点区域'].TFXQ.grey+this.GKDData['双流区华阳重点区域'].TFXQ.black}个点位，达标${this.GKDData['双流区华阳重点区域'].TFXQ.green}个，超标${this.GKDData['双流区华阳重点区域'].TFXQ.red}个，正常离线${this.GKDData['双流区华阳重点区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区华阳重点区域'].TFXQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区华阳核心区域'].TFXQ.green + this.GKDData['双流区华阳核心区域'].TFXQ.red+this.GKDData['双流区华阳核心区域'].TFXQ.grey+this.GKDData['双流区华阳核心区域'].TFXQ.black}个点位，达标${this.GKDData['双流区华阳核心区域'].TFXQ.green}个，超标${this.GKDData['双流区华阳核心区域'].TFXQ.red}个，正常离线${this.GKDData['双流区华阳核心区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区华阳核心区域'].TFXQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker11.on('mouseover', function() {
              infoWindowhuayang.open(that.aliMap, newMarker11.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker11.on('mouseout', function() {
              infoWindowhuayang.close();
            });

          }

          //双流区查看到的数据
          if(this.contentData.code === "510116" ){
            const infoWindowkexuecheng = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区科学城重点区域'].TFXQ.green + this.GKDData['双流区科学城重点区域'].TFXQ.red+this.GKDData['双流区科学城重点区域'].TFXQ.grey+this.GKDData['双流区科学城重点区域'].TFXQ.black}个点位，达标${this.GKDData['双流区科学城重点区域'].TFXQ.green}个，超标${this.GKDData['双流区科学城重点区域'].TFXQ.red}个，正常离线${this.GKDData['双流区科学城重点区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区科学城重点区域'].TFXQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                 <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区科学城核心区域'].TFXQ.green + this.GKDData['双流区科学城核心区域'].TFXQ.red+this.GKDData['双流区科学城核心区域'].TFXQ.grey+this.GKDData['双流区科学城核心区域'].TFXQ.black}个点位，达标${this.GKDData['双流区科学城核心区域'].TFXQ.green}个，超标${this.GKDData['双流区科学城核心区域'].TFXQ.red}个，正常离线${this.GKDData['双流区科学城核心区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区科学城核心区域'].TFXQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker10.on('mouseover', function() {
              infoWindowkexuecheng.open(that.aliMap, newMarker10.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker10.on('mouseout', function() {
              infoWindowkexuecheng.close();
            });
            // 鼠标悬停窗口
            const infoWindowhuayang = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区华阳重点区域'].TFXQ.green + this.GKDData['双流区华阳重点区域'].TFXQ.red+this.GKDData['双流区华阳重点区域'].TFXQ.grey+this.GKDData['双流区华阳重点区域'].TFXQ.black}个点位，达标${this.GKDData['双流区华阳重点区域'].TFXQ.green}个，超标${this.GKDData['双流区华阳重点区域'].TFXQ.red}个，正常离线${this.GKDData['双流区华阳重点区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区华阳重点区域'].TFXQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">双流区，${this.GKDData['双流区华阳重点区域'].SLQ.green + this.GKDData['双流区华阳重点区域'].SLQ.red+this.GKDData['双流区华阳重点区域'].SLQ.grey+this.GKDData['双流区华阳重点区域'].SLQ.black}个点位，达标${this.GKDData['双流区华阳重点区域'].SLQ.green}个，超标${this.GKDData['双流区华阳重点区域'].SLQ.red}个，正常离线${this.GKDData['双流区华阳重点区域'].SLQ.grey}个，异常离线${this.GKDData['双流区华阳重点区域'].SLQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker11.on('mouseover', function() {
              infoWindowhuayang.open(that.aliMap, newMarker11.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker11.on('mouseout', function() {
              infoWindowhuayang.close();
            });

          }


          if(deviceDetail.length === 0){
            const infoWindowkexuecheng = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区科学城重点区域'].TFXQ.green + this.GKDData['双流区科学城重点区域'].TFXQ.red+this.GKDData['双流区科学城重点区域'].TFXQ.grey+this.GKDData['双流区科学城重点区域'].TFXQ.black}个点位，达标${this.GKDData['双流区科学城重点区域'].TFXQ.green}个，超标${this.GKDData['双流区科学城重点区域'].TFXQ.red}个，正常离线${this.GKDData['双流区科学城重点区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区科学城重点区域'].TFXQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                 <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区科学城核心区域'].TFXQ.green + this.GKDData['双流区科学城核心区域'].TFXQ.red+this.GKDData['双流区科学城核心区域'].TFXQ.grey+this.GKDData['双流区科学城核心区域'].TFXQ.black}个点位，达标${this.GKDData['双流区科学城核心区域'].TFXQ.green}个，超标${this.GKDData['双流区科学城核心区域'].TFXQ.red}个，正常离线${this.GKDData['双流区科学城核心区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区科学城核心区域'].TFXQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker10.on('mouseover', function() {
              infoWindowkexuecheng.open(that.aliMap, newMarker10.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker10.on('mouseout', function() {
              infoWindowkexuecheng.close();
            });
            // 鼠标悬停窗口
            const infoWindowhuayang = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['双流区华阳重点区域'].GXNQ.green + this.GKDData['双流区华阳重点区域'].GXNQ.red+this.GKDData['双流区华阳重点区域'].GXNQ.grey+this.GKDData['双流区华阳重点区域'].GXNQ.black}个点位，达标${this.GKDData['双流区华阳重点区域'].GXNQ.green}个，超标${this.GKDData['双流区华阳重点区域'].GXNQ.red}个，正常离线${this.GKDData['双流区华阳重点区域'].GXNQ.grey}个，异常离线${this.GKDData['双流区华阳重点区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">双流区，${this.GKDData['双流区华阳重点区域'].SLQ.green + this.GKDData['双流区华阳重点区域'].SLQ.red+this.GKDData['双流区华阳重点区域'].SLQ.grey+this.GKDData['双流区华阳重点区域'].SLQ.black}个点位，达标${this.GKDData['双流区华阳重点区域'].SLQ.green}个，超标${this.GKDData['双流区华阳重点区域'].SLQ.red}个，正常离线${this.GKDData['双流区华阳重点区域'].SLQ.grey}个，异常离线${this.GKDData['双流区华阳重点区域'].SLQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区华阳重点区域'].TFXQ.green + this.GKDData['双流区华阳重点区域'].TFXQ.red+this.GKDData['双流区华阳重点区域'].TFXQ.grey+this.GKDData['双流区华阳重点区域'].TFXQ.black}个点位，达标${this.GKDData['双流区华阳重点区域'].TFXQ.green}个，超标${this.GKDData['双流区华阳重点区域'].TFXQ.red}个，正常离线${this.GKDData['双流区华阳重点区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区华阳重点区域'].TFXQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">高新南区，${this.GKDData['双流区华阳核心区域'].GXNQ.green + this.GKDData['双流区华阳核心区域'].GXNQ.red+this.GKDData['双流区华阳核心区域'].GXNQ.grey+this.GKDData['双流区华阳核心区域'].GXNQ.black}个点位，达标${this.GKDData['双流区华阳核心区域'].GXNQ.green}个，超标${this.GKDData['双流区华阳核心区域'].GXNQ.red}个，正常离线${this.GKDData['双流区华阳核心区域'].GXNQ.grey}个，异常离线${this.GKDData['双流区华阳核心区域'].GXNQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">天府新区，${this.GKDData['双流区华阳核心区域'].TFXQ.green + this.GKDData['双流区华阳核心区域'].TFXQ.red+this.GKDData['双流区华阳核心区域'].TFXQ.grey+this.GKDData['双流区华阳核心区域'].TFXQ.black}个点位，达标${this.GKDData['双流区华阳核心区域'].TFXQ.green}个，超标${this.GKDData['双流区华阳核心区域'].TFXQ.red}个，正常离线${this.GKDData['双流区华阳核心区域'].TFXQ.grey}个，异常离线${this.GKDData['双流区华阳核心区域'].TFXQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker11.on('mouseover', function() {
              infoWindowhuayang.open(that.aliMap, newMarker11.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker11.on('mouseout', function() {
              infoWindowhuayang.close();
            });
          }


        }

        // 青白江区新增青白江技师分院固定点位                                     龙泉驿区                                新都区                                 金堂县
        if(this.contentData.code === "510113" || this.contentData.code === "510112" || this.contentData.code === "510114" || this.contentData.code === "510121" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker12 = new AMap.Marker({
            position: [104.388539,30.742917],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('青白江技师分院',[104.388539,30.742917],[-53, 15])
          // 绘制青白江技师分院半径为1公里的圆
          const circleqingbaijiang1 = new AMap.Circle({
            center: [104.388539,30.742917],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleqingbaijiang1.setMap(this.aliMap);
          // 绘制青白江技师分院半径为5公里的圆
          const circleqingbaijiang5 = new AMap.Circle({
            center: [104.388539,30.742917],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleqingbaijiang5.setMap(this.aliMap);
          // 绘制(青白江技师分院核心区域)
          this.fixedPolygon(qingbaijiang1Km)
          // 绘制(青白江技师分院的重点区域)
          this.fixedPolygon(qingbaijiang3Km)
          // 鼠标悬停窗口，根据登录账号的不同实现不同的文字样式
          if(this.contentData.code === "510113"){
            const infoWindowqingbaijiang = new AMap.InfoWindow({
              isCustom: true, // 禁用默认样式
              content: `
            <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
              <p>
                <span style="color:#c7c7cc">重点区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">青白江区，${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.green + this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.red + this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.grey + this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.black}个点位，达标${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.green}个，超标${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.red}个，正常离线${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.grey}个，异常离线${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.black}个</span>
              </p>
              <p>
                <span style="color:#c7c7cc">核心区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">青白江区，${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.green + this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.red + this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.grey + this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.black}个点位，达标${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.green}个，超标${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.red}个，正常离线${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.grey}个，异常离线${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.black}个</span>
              </p>
            </div>
          `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker12.on('mouseover', function() {
              infoWindowqingbaijiang.open(that.aliMap, newMarker12.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker12.on('mouseout', function() {
              infoWindowqingbaijiang.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowqingbaijiang = new AMap.InfoWindow({
              isCustom: true, // 禁用默认样式
              content: `
            <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
              <p>
                <span style="color:#c7c7cc">重点区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">青白江区，${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.green + this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.red + this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.grey + this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.black}个点位，达标${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.green}个，超标${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.red}个，正常离线${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.grey}个，异常离线${this.GKDData['青白江区青白江技师分院重点区域'].QBJQ.black}个</span>
              </p>
              <p>
                <span style="color:#c7c7cc">金堂县，${this.GKDData['青白江区青白江技师分院重点区域'].JTX.green + this.GKDData['青白江区青白江技师分院重点区域'].JTX.red + this.GKDData['青白江区青白江技师分院重点区域'].JTX.grey + this.GKDData['青白江区青白江技师分院重点区域'].JTX.black}个点位，达标${this.GKDData['青白江区青白江技师分院重点区域'].JTX.green}个，超标${this.GKDData['青白江区青白江技师分院重点区域'].JTX.red}个，正常离线${this.GKDData['青白江区青白江技师分院重点区域'].JTX.grey}个，异常离线${this.GKDData['青白江区青白江技师分院重点区域'].JTX.black}个</span>
              </p>
              <p>
                <span style="color:#c7c7cc">核心区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">青白江区，${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.green + this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.red + this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.grey + this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.black}个点位，达标${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.green}个，超标${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.red}个，正常离线${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.black}个，异常离线${this.GKDData['青白江区青白江技师分院核心区域'].QBJQ.black}个</span>
              </p>
            </div>
          `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker12.on('mouseover', function() {
              infoWindowqingbaijiang.open(that.aliMap, newMarker12.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker12.on('mouseout', function() {
              infoWindowqingbaijiang.close();
            });
          }

          //展示龙泉驿区看到该国控点的统计信息
          if(this.contentData.code === "510112"){
            const infoWindowqingbaijiang = new AMap.InfoWindow({
              isCustom: true, // 禁用默认样式
              content: `
            <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
              <p>
                <span style="color:#c7c7cc">重点区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">无</span>
              </p>
              <p>
                <span style="color:#c7c7cc">核心区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">无</span>
              </p>
            </div>
          `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker12.on('mouseover', function() {
              infoWindowqingbaijiang.open(that.aliMap, newMarker12.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker12.on('mouseout', function() {
              infoWindowqingbaijiang.close();
            });
          }

          //展示新都区看到该国控点的统计信息
          if(this.contentData.code === "510114"){
            const infoWindowqingbaijiang = new AMap.InfoWindow({
              isCustom: true, // 禁用默认样式
              content: `
            <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
              <p>
                <span style="color:#c7c7cc">重点区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">无</span>
              </p>
              <p>
                <span style="color:#c7c7cc">核心区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">无</span>
              </p>
            </div>
          `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker12.on('mouseover', function() {
              infoWindowqingbaijiang.open(that.aliMap, newMarker12.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker12.on('mouseout', function() {
              infoWindowqingbaijiang.close();
            });
          }

          //展示金堂县看到该国控点的统计信息
          if(this.contentData.code === "510121"){
            const infoWindowqingbaijiang = new AMap.InfoWindow({
              isCustom: true, // 禁用默认样式
              content: `
            <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
              <p>
                <span style="color:#c7c7cc">重点区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">金堂县，${this.GKDData['青白江区青白江技师分院重点区域'].JTX.green + this.GKDData['青白江区青白江技师分院重点区域'].JTX.red + this.GKDData['青白江区青白江技师分院重点区域'].JTX.grey + this.GKDData['青白江区青白江技师分院重点区域'].JTX.black}个点位，达标${this.GKDData['青白江区青白江技师分院重点区域'].JTX.green}个，超标${this.GKDData['青白江区青白江技师分院重点区域'].JTX.red}个，正常离线${this.GKDData['青白江区青白江技师分院重点区域'].JTX.grey}个，异常离线${this.GKDData['青白江区青白江技师分院重点区域'].JTX.black}个</span>
              </p>
              <p>
                <span style="color:#c7c7cc">核心区域：</span>
              </p>
              <p>
                <span style="color:#c7c7cc">无</span>
              </p>
            </div>
          `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker12.on('mouseover', function() {
              infoWindowqingbaijiang.open(that.aliMap, newMarker12.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker12.on('mouseout', function() {
              infoWindowqingbaijiang.close();
            });
          }


        }

        // 温江区新增光华大道三段固定点位                                         双流区                                 青羊区
        if(this.contentData.code === "510115" || this.contentData.code === "510116" || this.contentData.code === "510105" || (deviceDetail.length === 0&&this.contentData.code !== "gxdq"&&this.contentData.code !== "gxxq"&&this.contentData.code !== "510114") ){
          const newMarker13 = new AMap.Marker({
            position: [103.852129,30.692454],
            icon: this.dotColorFormatter('redFiveStar'),
            anchor:'center',
            offset: new AMap.Pixel(0, 0),
            zIndex: 1,
            map: that.aliMap // 直接通过配置项绑定地图
          })
          // 创建文本标签
          this.fixedMarkerLable('光华大道三段',[103.852129,30.692454],[-45, 15])
          // 绘制光华大道三段半径为1公里的圆
          const circleguanghua1 = new AMap.Circle({
            center: [103.852129,30.692454],
            radius: 1000, // 半径1公里
            strokeColor: '#5099E0', // 蓝色线条
            strokeWeight: 2,
            strokeDasharray: [30, 30], // 虚线样式，5个像素的实线，5个像素的空白
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleguanghua1.setMap(this.aliMap);
          // 绘制光华大道三段半径为5公里的圆
          const circleguanghua5 = new AMap.Circle({
            center: [103.852129,30.692454],
            radius: 5000, // 半径5公里
            strokeColor: '#006FF1', // 蓝色线条
            strokeWeight: 2,
            fillColor: 'none', // 填充颜色，透明度为0.1
            zIndex: 1
          });
          circleguanghua5.setMap(this.aliMap);
          // 绘制(光华大道三段核心区域)
          this.fixedPolygon(guanghua1Km)
          // 绘制(光华大道三段的重点区域)
          this.fixedPolygon(guanghua3Km)
          // 鼠标悬停窗口，根据登录账号的不同实现不同的文字样式
          if(this.contentData.code === "510115"){
            const infoWindowguanghua = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">温江区，${this.GKDData['温江区光华大道三段重点区域'].WJQ.green + this.GKDData['温江区光华大道三段重点区域'].WJQ.red+this.GKDData['温江区光华大道三段重点区域'].WJQ.grey+this.GKDData['温江区光华大道三段重点区域'].WJQ.black}个点位，达标${this.GKDData['温江区光华大道三段重点区域'].WJQ.green}个，超标${this.GKDData['温江区光华大道三段重点区域'].WJQ.red}个，正常离线${this.GKDData['温江区光华大道三段重点区域'].WJQ.grey}个，异常离线${this.GKDData['温江区光华大道三段重点区域'].WJQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">温江区，${this.GKDData['温江区光华大道三段核心区域'].WJQ.green + this.GKDData['温江区光华大道三段核心区域'].WJQ.red+this.GKDData['温江区光华大道三段核心区域'].WJQ.grey+this.GKDData['温江区光华大道三段核心区域'].WJQ.black}个点位，达标${this.GKDData['温江区光华大道三段核心区域'].WJQ.green}个，超标${this.GKDData['温江区光华大道三段核心区域'].WJQ.red}个，正常离线${this.GKDData['温江区光华大道三段核心区域'].WJQ.grey}个，异常离线${this.GKDData['温江区光华大道三段核心区域'].WJQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker13.on('mouseover', function() {
              infoWindowguanghua.open(that.aliMap, newMarker13.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker13.on('mouseout', function() {
              infoWindowguanghua.close();
            });
          }

          if(deviceDetail.length === 0){
            const infoWindowguanghua = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">温江区，${this.GKDData['温江区光华大道三段重点区域'].WJQ.green + this.GKDData['温江区光华大道三段重点区域'].WJQ.red+this.GKDData['温江区光华大道三段重点区域'].WJQ.grey+this.GKDData['温江区光华大道三段重点区域'].WJQ.black}个点位，达标${this.GKDData['温江区光华大道三段重点区域'].WJQ.green}个，超标${this.GKDData['温江区光华大道三段重点区域'].WJQ.red}个，正常离线${this.GKDData['温江区光华大道三段重点区域'].WJQ.grey}个，异常离线${this.GKDData['温江区光华大道三段重点区域'].WJQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['温江区光华大道三段重点区域'].QYQ.green + this.GKDData['温江区光华大道三段重点区域'].QYQ.red+this.GKDData['温江区光华大道三段重点区域'].QYQ.grey+this.GKDData['温江区光华大道三段重点区域'].QYQ.black}个点位，达标${this.GKDData['温江区光华大道三段重点区域'].QYQ.green}个，超标${this.GKDData['温江区光华大道三段重点区域'].QYQ.red}个，正常离线${this.GKDData['温江区光华大道三段重点区域'].QYQ.grey}个，异常离线${this.GKDData['温江区光华大道三段重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">温江区，${this.GKDData['温江区光华大道三段核心区域'].WJQ.green + this.GKDData['温江区光华大道三段核心区域'].WJQ.red+this.GKDData['温江区光华大道三段核心区域'].WJQ.grey+this.GKDData['温江区光华大道三段核心区域'].WJQ.black}个点位，达标${this.GKDData['温江区光华大道三段核心区域'].WJQ.green}个，超标${this.GKDData['温江区光华大道三段核心区域'].WJQ.red}个，正常离线${this.GKDData['温江区光华大道三段核心区域'].WJQ.grey}个，异常离线${this.GKDData['温江区光华大道三段核心区域'].WJQ.black}个</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker13.on('mouseover', function() {
              infoWindowguanghua.open(that.aliMap, newMarker13.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker13.on('mouseout', function() {
              infoWindowguanghua.close();
            });
          }

          //双流区看到的该国控点的数据
          if(this.contentData.code === "510116"){
            const infoWindowguanghua = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker13.on('mouseover', function() {
              infoWindowguanghua.open(that.aliMap, newMarker13.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker13.on('mouseout', function() {
              infoWindowguanghua.close();
            });
          }

          //青羊区看到的该国控点的数据
          if(this.contentData.code === "510105"){
            const infoWindowguanghua = new AMap.InfoWindow({
              isCustom: true,// 禁用默认样式
              content: `
                <div style="border:1px solid #03608C;padding:8rem 16rem;background-color:#012954;opacity:0.8;font-size: 14rem;min-width: 240rem;max-width:500rem;">
                  <p>
                  <span style="color:#c7c7cc">重点区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">青羊区，${this.GKDData['温江区光华大道三段重点区域'].QYQ.green + this.GKDData['温江区光华大道三段重点区域'].QYQ.red+this.GKDData['温江区光华大道三段重点区域'].QYQ.grey+this.GKDData['温江区光华大道三段重点区域'].QYQ.black}个点位，达标${this.GKDData['温江区光华大道三段重点区域'].QYQ.green}个，超标${this.GKDData['温江区光华大道三段重点区域'].QYQ.red}个，正常离线${this.GKDData['温江区光华大道三段重点区域'].QYQ.grey}个，异常离线${this.GKDData['温江区光华大道三段重点区域'].QYQ.black}个</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">核心区域：</span>
                  </p>
                  <p>
                  <span style="color:#c7c7cc">无</span>
                  </p>
                </div>
              `, // 信息窗口的内容
              offset: new AMap.Pixel(0, -30) // 调整信息窗口的位置
            });
            // 绑定点击事件
            newMarker13.on('mouseover', function() {
              infoWindowguanghua.open(that.aliMap, newMarker13.getPosition());
            });
            // 绑定鼠标移出事件，关闭信息窗口
            newMarker13.on('mouseout', function() {
              infoWindowguanghua.close();
            });
          }


        }

      }



      if (that.lng != "" && that.lat != "") {
        that.aliMap.setCenter([that.lng, that.lat])
      }
    },

    getData() {
      const installData = []
      const complianceData = []
      const dataMap = complianceData.map((item) => {
        installData.map((vo) => {
          if (item.K.split('/').join('') === vo.K.split('/').join('')) {
            item.name = vo.N
            item.value = item.V
          }
        })
        return item
      })
      this.$set(this.config, 'data', dataMap)
      this.key++
    },
    boardDataChange(data) {
      this.$store.commit('setNewBoardData', {res: data, dataObj: this.contentData})
    },
  },
  watch: {
    onlineDevice: {
      handler: async function () {
        // 确保组件已经挂载并且地图容器存在
        if (!this._isMounted) {
          return;
        }
        const accountUserString = sessionStorage.getItem('user');
        const accountUserObj = JSON.parse(accountUserString)
        if (accountUserObj.Info && accountUserObj.Info.pid &&accountUserObj.Info.pid.slice(0, 6) == "/1199/") {
          // console.log('只有成都才有这个')
          await this.getChengDuPoint()
        }
        this.initData()
      },
      deep: true,
      immediate: true
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.echarts {
  width: 100%;
  height: 100%;
  position: relative;
}

.large {
  width: 23vw;
  height: 38vh;
}

.exceed_content {
  position: absolute;
  bottom: 180rem;
  right: 440rem;
  font-size: 12px;
  color: #c7c7cc;
  min-width: 12vw;
  background: #011d24;
  opacity: 0.8;
  background: rgba(21, 55, 135, 0.8);

  .ul_head {
    margin: 0;
    padding: 0;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: #c7c7cc;
    }

    .li_item {
      display: flex;
      justify-content: space-around;
      height: 4vh;
      line-height: 4vh;

      span {
        text-align: center;
        display: inline-block;
      }

      .item1 {
        width: 40%;
      }

      .item2,
      .item3 {
        width: 30%;
      }

      .item-head {
        cursor: pointer;
      }
    }
  }

  .ul_cont {
    margin: 0;
    padding: 0;
    height: 28vh;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: #c7c7cc;
    }

    .li_item {
      display: flex;
      justify-content: space-around;
      height: 4vh;
      line-height: 4vh;

      span {
        text-align: center;
        display: inline-block;
      }

      .item1 {
        width: 40%;
      }

      .item2,
      .item3 {
        width: 40%;
      }
    }
  }

  .exceed_content:hover {
    cursor: pointer;
  }
}
.el-table {
  opacity: 0.8;
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 7px; /*滚动条宽度*/
    height: 10px; /*滚动条高度*/
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: 0px 1px 3px #071e4a inset; /*滚动条的背景区域的内阴影*/
    border-radius: 10px; /*滚动条的背景区域的圆角*/
    background-color: #071e4a; /*滚动条的背景颜色*/
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    box-shadow: 0px 1px 3px rgb(21, 55, 135) inset; /*滚动条的内阴影*/
    border-radius: 10px; /*滚动条的圆角*/
    background-color: rgb(21, 55, 135); /*滚动条的背景颜色*/
  }
}
</style>
